import { useContext, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { CadastroContext } from '../../../../contexts/CadastroContext';
import InputMask from 'react-input-mask';
import AlertMessage from '../../../Alert';

const AsoValidarCnpj = () => {
  const [cnpj, setCnpj] = useState('');
  const [alert, setAlert] = useState({ show: false, message: "", variant: "success" });
  const [disabled, setDisabled] = useState(true);
  const { cadastro, handleCadastroChange } = useContext(CadastroContext);
  const navigate = useNavigate();

  const cnpjCharValue = (char: string) => char.toUpperCase().charCodeAt(0) - 48;

  const validarCNPJ = (value: string) => {
    const cnpj = value.replace(/[\.\-\/\s]/g, '').toUpperCase();

    if (cnpj.length !== 14) return false;

    // Valida formato: 12 alfanuméricos + 2 dígitos
    if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false;

    // Elimina CNPJs inválidos conhecidos
    if (/^(.)\1{13}$/.test(cnpj)) {
        return false;
    }

    // Cálculo do primeiro dígito verificador
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += cnpjCharValue(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(0))) {
        return false;
    }

    // Cálculo do segundo dígito verificador
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += cnpjCharValue(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(1))) {
        return false;
    }

    return true;
  }

  const handleCnpjChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.toUpperCase();
    const cnpjInput = value.replace(/[\.\-\/\s]/g, '');
    if (cnpjInput.length === 14) {
      setCnpj(value);
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const handleSubmit = () => {
    if (cnpj && validarCNPJ(cnpj)) {
      cadastro.cnpj = cnpj;
      cadastro.cnpjValidado = true;
      handleCadastroChange(cadastro);
      return navigate("/aso/registro/razao-social");
    } else {
      setAlert({ show: true, message: "Insira um CNPJ válido!", variant: "error" });
    }
  };

  return (
    <>
      <div className="aso-container-cnpj">
        <div className="aso-titulo-container-cnpj">
          <div className="aso-titulo-cnpj">
            Qual é o número de CNPJ da sociedade?
          </div>
        </div>
        <div className="aso-container-card-cnpj">
          <Card className="aso-card-cnpj">
            <div className="aso-card-content-container-cnpj">
              <div className="aso-card-content-cnpj-un">
                <div className="aso-card-content-cnpj-deux">
                  <label htmlFor="cnpj-input" className="label-container">
                    <span className="aso-card-content-cnpj-deux-label-span">
                      Número
                    </span>
                  </label>
                  <div className="aso-card-content-container-cnpj-deux-input">
                    <span className="aso-card-content-cnpj-deux-input-prefix">
                      CNPJ
                    </span>
                    <InputMask
                      type="text"
                      mask="**.***.***/****-99"
                      pattern="[A-Za-z0-9]*"
                      id="cnpj-input"
                      title="Digite um CNPJ"
                      minLength={14}
                      className="aso-card-content-cnpj-deux-input"
                      style={{ textTransform: 'uppercase' }}
                      onChange={(e: any) => handleCnpjChange(e)}
                    />
                  </div>
                  <div className="aso-card-content-cnpj-deux-input-span">
                    <span>Escreva apenas números, sem traços nem pontos.</span>
                  </div>
                </div>
              </div>
            </div>
          </Card>
          <div className="aso-button-cnpj-container">
            <Button
              variant="primary"
              className="aso-button-cnpj-content"
              onClick={() =>
                navigate(`/aso/registro/validar-info-empresa/${cadastro.idConsulta}`)
              }
            >
              Voltar
            </Button>
            <Button
              variant="primary"
              className="aso-button-cnpj-content"
              onClick={handleSubmit}
              disabled={disabled}
            >
              Continuar
            </Button>
          </div>
        </div>
      </div>
      <AlertMessage
        show={alert.show}
        message={alert.message}
        variant={alert.variant}
        onClose={() => setAlert({ ...alert, show: false })}
      />
    </>  
  );
}

export default AsoValidarCnpj;